import React from 'react';
import { CheckCircle2, Star } from 'lucide-react';
interface CompTier {
  units: string;
  bps: number;
  bonus?: number;
}
interface RoadmapTierProps {
  number: number;
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  isActive?: boolean;
  isNext?: boolean;
  colorClass: string;
  bgHeaderClass: string;
  requirements: React.ReactNode;
  focusItems: string[];
  compTiers: CompTier[];
  goal: string;
  goalSub: string;
}
export function RoadmapTier({
  number,
  title,
  subtitle,
  icon,
  isActive,
  isNext,
  colorClass,
  bgHeaderClass,
  requirements,
  focusItems,
  compTiers,
  goal,
  goalSub
}: RoadmapTierProps) {
  return <div className={`relative flex flex-col bg-white rounded-xl border-2 ${isActive ? 'border-blue-500 shadow-lg shadow-blue-100 z-10' : isNext ? 'border-gray-300 shadow-md' : 'border-gray-200'} transition-all duration-300`} data-id="element-634">
      {isActive && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-md z-20 whitespace-nowrap" data-id="element-635">
          You Are Here
        </div>}

      {isNext && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gray-700 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-md z-20 whitespace-nowrap" data-id="element-636">
          Next Target
        </div>}

      {/* Header */}
      <div className={`${bgHeaderClass} text-white p-4 pt-5 flex flex-col items-center text-center relative rounded-t-[10px] overflow-hidden`} data-id="element-637">
        <div className="absolute top-1 left-3 text-4xl font-black opacity-20 leading-none pointer-events-none" data-id="element-638">
          {number}
        </div>
        <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-2 z-10" data-id="element-639">
          {icon}
        </div>
        <h3 className="text-base font-extrabold tracking-tight leading-tight z-10 px-2" data-id="element-640">
          {title}
        </h3>
        {subtitle && <p className="text-[10px] font-medium uppercase tracking-wider opacity-90 mt-1 z-10 leading-tight" data-id="element-641">
            {subtitle}
          </p>}
      </div>

      <div className="p-4 flex-1 flex flex-col" data-id="element-642">
        {/* Requirements */}
        <div className="mb-4" data-id="element-643">
          <div className="flex items-center justify-center mb-3" data-id="element-644">
            <div className="h-px bg-gray-200 flex-1" data-id="element-645"></div>
            <span className="text-[10px] font-bold text-gray-400 uppercase px-2 tracking-wider" data-id="element-646">
              Requirements
            </span>
            <div className="h-px bg-gray-200 flex-1" data-id="element-647"></div>
          </div>
          <div className="min-h-[90px] flex flex-col justify-center" data-id="element-648">
            {requirements}
          </div>
        </div>

        {/* Focus */}
        <div className="mb-4" data-id="element-649">
          <div className="flex items-center justify-center mb-3" data-id="element-650">
            <div className="h-px bg-gray-200 flex-1" data-id="element-651"></div>
            <span className="text-[10px] font-bold text-gray-400 uppercase px-2 tracking-wider" data-id="element-652">
              Focus
            </span>
            <div className="h-px bg-gray-200 flex-1" data-id="element-653"></div>
          </div>
          <ul className="space-y-2" data-id="element-654">
            {focusItems.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-xs text-gray-700 font-medium" data-id="element-655">
                <CheckCircle2 className={`w-4 h-4 shrink-0 mt-0.5 ${colorClass}`} data-id="element-656" />
                <span className="leading-snug" data-id="element-657">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Goal Footer */}
        <div className="mt-4 flex items-start gap-3" data-id="element-658">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${colorClass.replace('text-', 'bg-').replace('600', '100').replace('500', '100').replace('[#0a1e5e]', 'blue-100')} ${colorClass}`} data-id="element-659">
            <Star className="w-4 h-4" data-id="element-660" />
          </div>
          <div className="min-w-0" data-id="element-661">
            <p className="text-[10px] font-bold text-gray-500 uppercase leading-tight mb-0.5" data-id="element-662">
              Goal:
            </p>
            <p className={`text-xs font-bold leading-tight ${colorClass} break-words`} data-id="element-663">
              {goal}
            </p>
            <p className="text-[10px] text-gray-600 font-medium leading-tight mt-0.5 break-words" data-id="element-664">
              {goalSub}
            </p>
          </div>
        </div>
      </div>
    </div>;
}